document.addEventListener('alpine:init', () => {
  Alpine.data('Swiper', (sw_options) => ({
    swiper: null,
    disable_on_breakpoints: '',
    init() {
      this.disable_on_breakpoints = this.$el.dataset.disableOnBreakpoints ? this.$el.dataset.disableOnBreakpoints.split(',') : [];

      let resizeObserver = new ResizeObserver(this.InitSwiper.bind(this));
      resizeObserver.observe(this.$el);
    },
    InitSwiper() {
      if (!sw_options) {
        console.warn('No Swiper options provided');
        return;
      }

      // on swiper events
      sw_options.on = {
        slideChangeTransitionEnd: () => {
          // Manually update pagination bullets since its not working as expected
          let swiper = this.swiper??null;
          if (swiper) {
            let $activeSlide = swiper.slides.find(slide => slide.classList.contains('swiper-slide-active')); 
            let activeIndex = $activeSlide.dataset.swiperSlideIndex;
            swiper.pagination?.bullets.forEach((bullet, index) => {
              bullet.classList.toggle('swiper-pagination-bullet-active', index == activeIndex); 
            });
          }
        }
      };

      // Check if we need to disable the swiper on specific breakpoints
      let enable_swiper = true;
      this.disable_on_breakpoints.forEach(breakpoint => {
        if (window.matchMedia(breakpoint).matches) {
          if (this.swiper) {
            this.swiper.destroy(true, true);
          }
          enable_swiper = false; // Disable Swiper
        }
      });
      if (!enable_swiper) {
        this.$el.classList.add('swiper-disabled');
        return; // Don't initialize Swiper
      }

      this.$el.classList.remove('swiper-disabled');
      this.swiper = new Swiper(this.$el, sw_options);
    }
  }));
});